import { Icon } from 'components/UI'
import { useState } from 'react'

const Tooltip = ({ text, children, position }) => {
  const [visible, setVisible] = useState(false)

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className={`absolute flex gap-4 items-center bottom-full w-[500px] mb-2 px-4 py-4 border shadow text-sm text-black bg-white rounded right-0 ${position} whitespace-pre-line`}
        >
          <span>
            <Icon name={'alert'} />
          </span>
          <div className="flex-1 text-primary-100">{text}</div>
        </div>
      )}
    </div>
  )
}

export default Tooltip
